import { render, staticRenderFns } from "./ConcernElement.vue?vue&type=template&id=211979c8&"
import script from "./ConcernElement.vue?vue&type=script&lang=js&"
export * from "./ConcernElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports